import { useEffect, useState } from "react";
import { fetchMitecoBasins } from "../model/mitecoLayers.ts";
import type { MapMitecoMode } from "../model/mitecoLayers.ts";
import { MITECO_BASINS_STYLE } from "./mapStyles.ts";
import { MitecoSelectableLayer } from "./MitecoSelectableLayer.tsx";

const ATTRIBUTION = '&copy; <a href="https://www.miteco.gob.es">MITECO</a>';

/**
 * MITECO's official river basins — the coarser sibling of
 * MitecoSubBasinsLayer.tsx (118 features for the whole country vs.
 * 12,162), small enough to fetch as one file the first time this mode
 * picks it, no viewport-based splitting needed. Only mounted while
 * SubBasinsPanel.tsx's "Add from MITECO" mode is active AND set to this
 * layer — see SubBasinMap.tsx.
 */
export function MitecoBasinsLayer({ mode }: { mode: MapMitecoMode }) {
  const [data, setData] = useState<GeoJSON.FeatureCollection | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetchMitecoBasins().then((fetched) => {
      if (!cancelled) setData(fetched);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data) return null;
  return (
    <MitecoSelectableLayer
      data={data}
      style={MITECO_BASINS_STYLE}
      attribution={ATTRIBUTION}
      mode={mode}
    />
  );
}
